<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';

    @Component({
        props: {
            workspaceId: {
                type: Number,
                required: true
            },
            projectId: {
                type: Number,
                required: true
            }
        }
    })
    export default class DecisionNavigation extends Vue
    {

    }
</script>

<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" style="margin-bottom: 0;">
        <a class="navbar-brand" v-sanitizedHref="`/#/decision/kanban/${workspaceId}/${projectId}`">Kanban</a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navBar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navBar">
            <ul class="navbar-nav mr-auto">

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Manage
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/attributes/${workspaceId}/${projectId}`">Attributes</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/forms/${workspaceId}/${projectId}`">Forms</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/lists-manager/${workspaceId}/${projectId}`">Lists</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/notifications/${workspaceId}/${projectId}`">Notifications</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/dependencies/${workspaceId}/${projectId}`">Dependencies</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/pages/${workspaceId}/${projectId}`">Request pages</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/decision/people/${workspaceId}/${projectId}`">People</a>
                    </div>
                </li>

                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/decision/goals/${workspaceId}/${projectId}`">Evaluation</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/decision/assessments/${workspaceId}/${projectId}`">Assessments</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/decision/reports/${workspaceId}/${projectId}`">Reports</a>
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Account
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" v-sanitizedHref="`/#/projects/${workspaceId}`">Back to workspace</a>
                        <a class="dropdown-item" href="/#/organizations/users/dashboard">My dashboard</a>
                        <a class="dropdown-item" href="/#/organizations/users/account">Manage your account</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/organizations/sessions/close">Sign out</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<style scoped>
    .navbar {
        -webkit-box-shadow: 0 2px 6px 0 #999;
        -moz-box-shadow: 0 2px 6px 0 #999;
        box-shadow: 0 2px 6px 0 #999;
    }
</style>